export const formatMoneyRange = (salary: string): string => {
  const ranges = salary.split('-')
  const dashCount = (salary.match(/-/g) || []).length

  // Allow only one dash
  if (dashCount > 1) {
    // Return the original value if there's more than one dash to avoid incorrect formatting
    return salary
  }

  // Format each part: remove non-digit characters, convert to number, add commas
  const formattedRanges = ranges.map((range) => {
    const parsedNumber = parseInt(range.replace(/[^\d]+/g, ''), 10)
    // Handle cases where parsing results in NaN (e.g., empty string)
    if (isNaN(parsedNumber)) {
      return ''
    }
    return parsedNumber.toLocaleString()
  })

  // Join parts with dash
  return formattedRanges.join('-')
}

interface IMoneyRange {
  max: null | number
  min: null | number
}

export const getMinMaxMoneyRange = (salary: string): IMoneyRange => {
  const [min, max] = salary.replace(/[$,]/g, '').split('-')

  return {
    max: parseInt(max) || 0,
    min: parseInt(min) || 0,
  }
}

export const formatCurrencyThousands = (num: null | number | undefined): null | string => {
  if (!num) return null

  if (num >= 1000) {
    return '$' + (num / 1000).toFixed(0) + 'K'
  } else {
    return '$' + num
  }
}

export const formatMoney = ({
  amount,
  currencyCode = 'USD',
  locale = 'en-US',
}: {
  amount: number
  currencyCode?: string
  locale?: string
}) => {
  const formatter = new Intl.NumberFormat(locale, {
    currency: currencyCode,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'currency',
  })

  return formatter.format(amount)
}

export const formatMinMaxSalary = (min?: null | number, max?: null | number): string => {
  if (!min && !max) return ''

  if (min && !max) return `${formatMoney({ amount: min })}`
  if (!min && max) return `${formatMoney({ amount: max })}`

  return `${formatMoney({ amount: min ?? 0 })} - ${formatMoney({ amount: max ?? 0 })}`
}
